import { Body1, Header2 } from '@flatsy/core/MaterialUi/Typo'
import theme from '@flatsy/core/MuiTheme/theme'
import i18n from '@flatsy/utils/translations'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import clsx from 'clsx'
import React from 'react'
import useStyles from './Style'
import { ComponentsProps } from './Type'
import { ApplicantNameOrUndefined } from './Utils'

const QualificationHeader: React.FC<ComponentsProps> = ({
  onBackClicked,
  step,
  isSmall,
  mobileApplicants,
  currentApplicantId,
}) => {
  const classes = useStyles()

  const handleBack = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    if (onBackClicked) {
      onBackClicked()
    }
  }

  return (
    <div className={clsx(classes.header, isSmall && classes.headerSmall)}>
      {onBackClicked && (
        <a href="back" className={classes.back} onClick={handleBack}>
          <ArrowBackIcon className={classes.backIcon} />
          <span>{i18n.t('back')}</span>
        </a>
      )}
      {ApplicantNameOrUndefined(mobileApplicants, currentApplicantId) && (
        <Body1 fontColor={theme.palette.primary.dark} className={classes.headerApplicant}>
          {ApplicantNameOrUndefined(mobileApplicants, currentApplicantId)}
        </Body1>
      )}
      {step && step !== '' && (
        <Header2 fontColor={theme.palette.primary.dark} className={classes.headerTitle}>
          {step}
        </Header2>
      )}
    </div>
  )
}

export default QualificationHeader
